import { makeStyles } from "@mui/styles";
import { colors, Commons } from "styleguide";

const styles = makeStyles({
  container: {
    display: "flex",
    position: "relative",
    padding: "60px 0",
    [Commons.smallQuery]: {
      padding: "36px 0",
      gap: 18,
      flexWrap: "wrap",
    },
  },
  card: {
    flex: 1,
    color: colors.white,
    textAlign: "center",
    "& p": {
      fontSize: 54,
      margin: 0,
      lineHeight: "30px",
      [Commons.smallQuery]: {
        fontSize: 48,
        lineHeight: "24px",
      },
    },
    "& span": {
      fontSize: 18,
      color: colors.orange,
      lineHeight: "6px",
    },
    [Commons.smallQuery]: {
      margin: "24px 0",
    },
  },
});

export default styles;
